module.exports = __webpack_public_path__ + "static/media/playdiator-explaner-complete.a4f95665.jpg";